// Frontend-only mapping for additionalData JSON payload.
// Add new entries here to persist more form fields into additionalData
// without any backend entity/controller changes.
export const ADDITIONAL_DATA_FIELD_MAPPINGS = [
  { additionalKey: "dietaryRestrictions", formKey: "dietaryRestrictions" },
  { additionalKey: "specialization", formKey: "specialization" },
  { additionalKey: "designation", formKey: "designation" },
];

export const buildAdditionalDataPayload = ({
  formData,
  effectiveCategoriesHistory,
  effectiveRegistrationTypesHistory,
  fieldMappings = ADDITIONAL_DATA_FIELD_MAPPINGS,
}) => {
  const additionalData = {};

  fieldMappings.forEach(({ additionalKey, formKey }) => {
    const value = formData?.[formKey];

    if (typeof value === "string") {
      const trimmedValue = value.trim();
      if (trimmedValue) {
        additionalData[additionalKey] = trimmedValue;
      }
      return;
    }

    if (value !== undefined && value !== null && value !== "") {
      additionalData[additionalKey] = value;
    }
  });

  if (effectiveCategoriesHistory.length > 0) {
    additionalData.categoriesHistory = effectiveCategoriesHistory
      .map((entry) => ({
        id: entry?.id ?? null,
        value: entry?.value || "",
        selectedAt: entry?.selectedAt || new Date().toISOString(),
      }))
      .filter((entry) => entry.value);
  }

  if (effectiveRegistrationTypesHistory.length > 0) {
    additionalData.registrationTypesHistory = effectiveRegistrationTypesHistory
      .map((entry) => ({
        id: entry?.id ?? null,
        value: entry?.value || "",
        selectedAt: entry?.selectedAt || new Date().toISOString(),
      }))
      .filter((entry) => entry.value);
  }

  return additionalData;
};

export const buildConferenceRegistrationPayload = ({
  formData,
  conferenceName,
  currentHost,
  accompanyingPersons,
  effectiveCategoriesHistory,
  effectiveRegistrationTypesHistory,
  additionalFees = null,
  includeAccompanyingPersons = false,
  includeGender = false,
  includeIsaMembershipNumber = false,
} = {}) => {
  const payload = {
    email: formData.email,
    title: formData.title,
    firstName: formData.firstName,
    lastName: formData.lastName,
    phone: formData.mobile,
    country: formData.country,
    state: formData.state,
    city: formData.city,
    address: formData.address,
    zipCode: formData.pincode,
    conference: formData.conference || conferenceName || "",
    affiliation: formData.affiliation || "",
    institution: formData.institution || "",
    prefix: formData.prefix || "",
    fullNameCertificate: formData.fullNameCertificate,
    mciRegistered: formData.mciRegistered || "No",
    mciName: formData.mciName || "",
    mciNumber: formData.mciNumber || "",
    department: formData.department || "",
    departmentId: formData.departmentId,
    otherDepartment: formData.otherDepartment,
    category: formData.category || "TBD",
    categoryId: formData.categoryId,
    registrationType: formData.registrationType || "TBD",
    registrationTypeId: formData.registrationTypeId,
    membershipNumber: formData.membershipNumber || "",
    studentIdURL:
      formData.studentIdCard && !formData.studentIdCard.startsWith("data:")
        ? formData.studentIdCard
        : null,
    specialRequirements: formData.specialRequirements || "",
    accommodationNeeded: formData.accommodationNeeded || false,
    notes: formData.notes || "",
    additionalData: buildAdditionalDataPayload({
      formData,
      effectiveCategoriesHistory,
      effectiveRegistrationTypesHistory,
    }),
  };

  if (includeGender) {
    payload.gender = formData.gender;
  }

  if (includeIsaMembershipNumber) {
    payload.isaMembershipNumber = formData.isaMembershipNumber || "";
  }

  if (additionalFees !== null) {
    payload.additionalFees = additionalFees;
  }

  if (includeAccompanyingPersons) {
    payload.accompanyingPersons =
      accompanyingPersons.length > 0 ? accompanyingPersons : [];
  }

  return payload;
};
